import { Route } from 'react-router-dom';
import { ballonsDueToClubViewSchema } from './ballonsDueToClub';
import Main from '@app/main/tables/Main';

/**
 * Routes configurées pour le module BallonsDueToClub
 */
const BallonsDueToClubRoutes = [
    // Route de liste (principale)
    <Route
        key="ballons-due-to-club"
        path="ballonDueToClub"
        element={
            <Main
                key="ballons-due-to-club-main"
                pageConfig={ballonsDueToClubViewSchema}
            />
        }
    />,
];

export default BallonsDueToClubRoutes;
